/* @flow */
'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var waterfall = require('async/waterfall');

var parallel = require('async/parallel');

var Key = require('interface-datastore').Key;

var sh = require('./shard');

var KeytransformStore = require('./keytransform');

var shardKey = new Key(sh.SHARDING_FN);
var shardReadmeKey = new Key(sh.README_FN);
/* ::
import type {Datastore, Batch, Query, QueryResult, Callback} from 'interface-datastore'

import type {ShardV1} from './shard'
*/

/**
 * Backend independent abstraction of go-ds-flatfs.
 *
 * Wraps another datastore such that all values are stored
 * sharded according to the given sharding function.
 */

var ShardingDatastore =
/*#__PURE__*/
function () {
  /* :: shard: ShardV1 */

  /* :: child: Datastore<Buffer> */
  function ShardingDatastore(store
  /* : Datastore<Buffer> */
  , shard
  /* : ShardV1 */
  ) {
    _classCallCheck(this, ShardingDatastore);

    this.child = new KeytransformStore(store, {
      convert: this._convertKey.bind(this),
      invert: this._invertKey.bind(this)
    });
    this.shard = shard;
  }

  _createClass(ShardingDatastore, [{
    key: "open",
    value: function open(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.child.open(callback);
    }
  }, {
    key: "_convertKey",
    value: function _convertKey(key
    /* : Key */
    )
    /* : Key */
    {
      var s = key.toString();

      if (s === shardKey.toString() || s === shardReadmeKey.toString()) {
        return key;
      }

      var parent = new Key(this.shard.fun(s));
      return parent.child(key);
    }
  }, {
    key: "_invertKey",
    value: function _invertKey(key
    /* : Key */
    )
    /* : Key */
    {
      var s = key.toString();

      if (s === shardKey.toString() || s === shardReadmeKey.toString()) {
        return key;
      }

      return Key.withNamespaces(key.list().slice(1));
    }
  }, {
    key: "put",
    value: function put(key
    /* : Key */
    , val
    /* : Buffer */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.child.put(key, val, callback);
    }
  }, {
    key: "get",
    value: function get(key
    /* : Key */
    , callback
    /* : Callback<Buffer> */
    )
    /* : void */
    {
      this.child.get(key, callback);
    }
  }, {
    key: "has",
    value: function has(key
    /* : Key */
    , callback
    /* : Callback<bool> */
    )
    /* : void */
    {
      this.child.has(key, callback);
    }
  }, {
    key: "delete",
    value: function _delete(key
    /* : Key */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.child.delete(key, callback);
    }
  }, {
    key: "batch",
    value: function batch()
    /* : Batch<Buffer> */
    {
      return this.child.batch();
    }
  }, {
    key: "query",
    value: function query(q
    /* : Query<Buffer> */
    )
    /* : QueryResult<Buffer> */
    {
      var _this = this;

      var tq
      /* : Query<Buffer> */
      = {
        keysOnly: q.keysOnly,
        offset: q.offset,
        limit: q.limit,
        filters: [function (e, cb) {
          return cb(null, e.key.toString() !== shardKey.toString());
        }, function (e, cb) {
          return cb(null, e.key.toString() !== shardReadmeKey.toString());
        }]
      };

      if (q.prefix != null) {
        tq.filters.push(function (e, cb) {
          cb(null, _this._invertKey(e.key).toString().startsWith(q.prefix));
        });
      }

      if (q.filters != null) {
        var filters = q.filters.map(function (f) {
          return function (e, cb) {
            f(Object.assign({}, e, {
              key: _this._invertKey(e.key)
            }), cb);
          };
        });
        tq.filters = tq.filters.concat(filters);
      }

      if (q.orders != null) {
        tq.orders = q.orders.map(function (o) {
          return function (res, cb) {
            res.forEach(function (e) {
              e.key = _this._invertKey(e.key);
            });
            o(res, function (err, ordered) {
              if (err) {
                return cb(err);
              }

              ordered.forEach(function (e) {
                e.key = _this._convertKey(e.key);
              });
              cb(null, ordered);
            });
          };
        });
      }

      return this.child.query(tq);
    }
  }, {
    key: "close",
    value: function close(callback
    /* : Callback<void> */
    )
    /* : void */
    {
      this.child.close(callback);
    }
  }], [{
    key: "createOrOpen",
    value: function createOrOpen(store
    /* : Datastore<Buffer> */
    , shard
    /* : ShardV1 */
    , callback
    /* : Callback<ShardingDatastore> */
    )
    /* : void */
    {
      ShardingDatastore.create(store, shard, function (err) {
        if (err && err.message !== 'datastore exists') {
          return callback(err);
        }

        ShardingDatastore.open(store, callback);
      });
    }
  }, {
    key: "open",
    value: function open(store
    /* : Datastore<Buffer> */
    , callback
    /* : Callback<ShardingDatastore> */
    )
    /* : void */
    {
      waterfall([function (cb) {
        return sh.readShardFun('/', store, cb);
      }, function (shard, cb) {
        cb(null, new ShardingDatastore(store, shard));
      }], callback);
    }
  }, {
    key: "create",
    value: function create(store
    /* : Datastore<Buffer> */
    , shard
    /* : ShardV1 */
    , callback
    /* : Callback<void> */
    )
    /* : void */
    {
      store.has(shardKey, function (err, exists) {
        if (err) {
          return callback(err);
        }

        if (!exists) {
          var put = typeof store.putRaw === 'function' ? store.putRaw.bind(store) : store.put.bind(store);
          return parallel([function (cb) {
            return put(shardKey, Buffer.from(shard.toString() + '\n'), cb);
          }, function (cb) {
            return put(shardReadmeKey, Buffer.from(sh.readme), cb);
          }], function (err) {
            return callback(err);
          });
        }

        sh.readShardFun('/', store, function (err, diskShard) {
          if (err) {
            return callback(err);
          }

          var a = (diskShard || '').toString();
          var b = shard.toString();

          if (a !== b) {
            return callback(new Error("specified fun ".concat(b, " does not match repo shard fun ").concat(a)));
          }

          callback(new Error('datastore exists'));
        });
      });
    }
  }]);

  return ShardingDatastore;
}();

module.exports = ShardingDatastore;